import * as React from "react";
import { D3Component } from "./D3Component";
import { bar } from "sszvis";
export const Bar = (props) => (<D3Component datum={props.data} component={bar()
    .x(props.x)
    .y(props.y)
    .width(props.width)
    .height(props.height)
    .fill(props.fill)
    .stroke(props.stroke)
    .centerTooltip(props.centerTooltip)
    .tooltipAnchor(props.tooltipAnchor)
    .transition(props.transition)} renderElement={({ selectionRef }) => (<g ref={selectionRef} {...props.gProps}/>)}/>);



// WEBPACK FOOTER //
// ./src/sszvis-components/Bar.tsx